import {ChangeDetectionStrategy, Component, computed, inject, signal} from '@angular/core';
import { MaterialService } from '../material/material.service';
import { PanelStylesService } from '../panel-styles/panel-styles.service';
import {HeightService} from '../height/height.service';
import {WorksurfaceService} from '../worksurface/worksurface.service';
import {DoorService} from '../door/door.service';
import {TitleCasePipe} from '@angular/common';

@Component({
  selector: 'app-visuals',
  imports: [
    TitleCasePipe
  ],
  templateUrl: './visuals.html',
  styleUrl: './visuals.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Visuals {
  private panelStylesService = inject(PanelStylesService);
  protected materialService = inject(MaterialService);
  private heightService = inject(HeightService);
  private worksurfaceService = inject(WorksurfaceService);
  private doorService = inject(DoorService);

  protected selectedHeight = this.heightService.selectedHeight;
  protected selectedWorksurface = computed(() => this.worksurfaceService.selectedWorksurface());

  protected selectedPanelStyle = computed(() => this.panelStylesService.selectedStyle());
  protected selectedDoor = computed(() => this.doorService.selectedDoor());

  protected t0Mat = this.materialService.getSelection('T0');
  protected t1Mat = this.materialService.getSelection('T1');
  protected t2Mat = this.materialService.getSelection('T2');
  protected t3Mat = this.materialService.getSelection('T3');
  protected t4Mat = this.materialService.getSelection('T4');

  protected worksurface = this.worksurfaceService.selectedWorksurface;
  protected door = this.doorService.selectedDoor;

  readonly zones = computed(() => {
    const height = this.heightService.selectedHeight();
    const style = this.panelStylesService.selectedStyle();

    let result = ['T4', 'T3', 'T2', 'T1', 'T0'];

    if (height == 84) {
      result = result.filter(tab => tab !== 'T4');

      if(style?.endsWith('A')){
      } else if(style?.endsWith('B')){
        result = result.filter(tab => tab !== 'T3');
      } else if(style?.endsWith('C')) {
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T2');
      } else if(style?.endsWith('D')) {
        result = result.filter(tab => tab !== 'T2');
      } else if(style?.endsWith('E')) {
        result = result.filter(tab => tab !== 'T1');
      } else if(style?.endsWith('F')) {
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T1');
      } else if(style?.endsWith('G')) {
        result = result.filter(tab => tab !== 'T2');
        result = result.filter(tab => tab !== 'T1');
      } else {
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T2');
        result = result.filter(tab => tab !== 'T1');
      }
    } else if(height === 95 || height === 108) {
      if (style?.endsWith('A')){
      } else if(style?.endsWith('B')){
        result = result.filter(tab => tab !== 'T4');
      } else if(style?.endsWith('C')){
        result = result.filter(tab => tab !== 'T3');
      } else if(style?.endsWith('D')) {
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T4');
      } else if(style?.endsWith('E')) {
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T2');
      } else if(style?.endsWith('F')) {
        result = result.filter(tab => tab !== 'T4');
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T2');
      } else if(style?.endsWith('G')) {
        result = result.filter(tab => tab !== 'T2');
      } else if(style?.endsWith('H')) {
        result = result.filter(tab => tab !== 'T4');
        result = result.filter(tab => tab !== 'T2');
      } else if(style?.endsWith('I')) {
        result = result.filter(tab => tab !== 'T1');
      } else if(style?.endsWith('J')) {
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T1');
      } else if(style?.endsWith('K')) {
        result = result.filter(tab => tab !== 'T4');
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T1');
      } else if(style?.endsWith('L')) {
        result = result.filter(tab => tab !== 'T4');
        result = result.filter(tab => tab !== 'T1');
      } else if(style?.endsWith('M')) {
        result = result.filter(tab => tab !== 'T2');
        result = result.filter(tab => tab !== 'T1');
      } else if(style?.endsWith('N')) {
        result = result.filter(tab => tab !== 'T4');
        result = result.filter(tab => tab !== 'T2');
        result = result.filter(tab => tab !== 'T1');
      } else if(style?.endsWith('O')) {
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T2');
        result = result.filter(tab => tab !== 'T1');
      } else if(style?.endsWith('P')) {
        result = result.filter(tab => tab !== 'T4');
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T2');
        result = result.filter(tab => tab !== 'T1');
      }
    }

    return result;
  });


  protected selections = computed(() =>
    this.zones().map(zone => ({
      zone,
      ...this.materialService.getSelection(zone)()
    }))
  );

  protected t0Dir = computed(() => {
    const style = this.selectedPanelStyle();
    if (!style) return false;

    let height = "95";
    if(style.startsWith('95')) {
      height = "95";
    } else {
      height = "108";
    }

    if(this.selectedPanelStyle()?.startsWith('84')) {
      const endsWithAD = /[A-D]$/.test(style);
      const endsWithEF = /[E-F]$/.test(style);
      if (endsWithAD) {
        return 'T0';
      } else if (endsWithEF) {
        return 'T0_1';
      } else if (style.endsWith('G')){
        return 'T0_2';
      } else {
        return 'T0_3';
      }
    } else if(this.selectedPanelStyle()?.startsWith('95') || this.selectedPanelStyle()?.startsWith('108')) {
      const endsWithAH = /[A-H]$/.test(style);
      const endsWithIL = /[I-L]$/.test(style);
      const endsWithMN = /[M-N]$/.test(style);
      if (endsWithAH) {
        return 'T0';
      } else if (endsWithIL) {
        return 'T0_1';
      } else if (endsWithMN) {
        return 'T0_2';
      } else if (style.endsWith('O')) {
        return 'T0_3';
      } else if (style.endsWith('P')) {
        return 'T0_4/' + height;
      }else {
        return false;
      }
    } else {
      return false;
    }
  });

  protected t1Dir = computed(() => {
    const style = this.selectedPanelStyle();
    if (!style) return false;

    let height = "95";
    if(style.startsWith('95')) {
      height = "95";
    } else {
      height = "108";
    }

    if(this.selectedPanelStyle()?.startsWith('84')) {
      const endsWithAB = /[A-B]$/.test(style);
      if(endsWithAB) {
        return 'T1';
      } else if (style.endsWith('C')) {
        return 'T1_3';
      } else if (style.endsWith('D')) {
        return 'T1_2';
      } else {
        return false;
      }
    } else if(this.selectedPanelStyle()?.startsWith('95') || this.selectedPanelStyle()?.startsWith('108')) {
      const endsWithAD = /[A-D]$/.test(style);
      const endsWithGH = /[G-H]$/.test(style);
      if(endsWithAD) {
        return 'T1';
      } else if (endsWithGH) {
        return 'T1_2';
      } else if (style.endsWith('E')) {
        return 'T1_3';
      } else if (style.endsWith('F')) {
        return 'T1_4/' + height;
      } else {
        return false;
      }
    } else {
      return false;
    }
  });

  protected t2Dir = computed(() => {
    const style = this.selectedPanelStyle();
    if (!style) return false;

    let height = "95";
    if(style.startsWith('95')) {
      height = "95";
    } else {
      height = "108";
    }

    if(this.selectedPanelStyle()?.startsWith('84')) {
      if(style.endsWith('A') || style.endsWith('E')) {
        return 'T2';
      } else if (style.endsWith('B') || style.endsWith('F')) {
        return 'T2_3';
      } else {
        return false;
      }
    } else if (this.selectedPanelStyle()?.startsWith('95') || this.selectedPanelStyle()?.startsWith('108')) {
      const endsWithAB = /[A-B]$/.test(style);

      if(endsWithAB || style.endsWith('I') || style.endsWith('L')) {
        return 'T2';
      } else if (style.endsWith('C') || style.endsWith('J')) {
        return 'T2_3';
      } else if (style.endsWith('D') || style.endsWith('K')) {
        return 'T2_4/' + height;
      } else {
        return false;
      }
    } else {
      return false;
    }
  });

  protected t3Dir = computed(() => {
    const style = this.selectedPanelStyle();
    if (!style) return false;

    let height = "95";
    if(style.startsWith('95')) {
      height = "95";
    } else {
      height = "108";
    }

    if(this.selectedPanelStyle()?.startsWith('84')) {
      if (style.endsWith('A') || style.endsWith('D') || style.endsWith('E') || style.endsWith('G')) {
        return 'T3';
      } else {
        return false;
      }
    } else if (this.selectedPanelStyle()?.startsWith('95') || this.selectedPanelStyle()?.startsWith('108')) {
      if (style.endsWith('A') || style.endsWith('G') || style.endsWith('I') || style.endsWith('M')) {
        return 'T3';
      } else if (style.endsWith('B') || style.endsWith('H') || style.endsWith('L') || style.endsWith('N')) {
        return 'T3_4/' + height;
      } else {
        return false;
      }
    } else {
      return false;
    }
  });

  protected t4Dir = computed(() => {
    const style = this.selectedPanelStyle();
    if (!style) return false;

    let height = "95";
    if(style.startsWith('95')) {
      height = "95";
    } else {
      height = "108";
    }

    if(this.selectedPanelStyle()?.startsWith('84')) {
      return false;
    } else if (this.selectedPanelStyle()?.startsWith('95') || this.selectedPanelStyle()?.startsWith('108')) {
      if (style.endsWith('A') || style.endsWith('C') || style.endsWith('E') || style.endsWith('G') || style.endsWith('I') || style.endsWith('J') || style.endsWith('M') || style.endsWith('O')) {
        return 'T4/' + height;
      } else {
        return false;
      }
    } else {
      return false;
    }
  });
}
